import React, { Component } from "react";
import ReactAudioPlayer from "react-audio-player";
import { scale, clamp } from "./functional.js";
import { Log } from "./log.js";
import { Settings } from "./settings";

const log = new Log(Settings.logLevel);

class PTSelectableDialogue extends Component {
  constructor(props) {
    super(props);
    this.clicked = false;
    this.audioEnded = false;
    this.baseClassNames = ["inky-output"];
    this.textLengthDomain = [80, 200];
    this.fontSizeRange = [20, 13];
    this.clickHandler = this.clickHandler.bind(this);
    this.mouseOverHandler = this.mouseOverHandler.bind(this);
    this.mouseOutHandler = this.mouseOutHandler.bind(this);
    this.onAudioEnded = this.onAudioEnded.bind(this);
  }
  render() {
    if (this.props.text) {
      return (
        <div
          className={this.getClassNames()}
          onMouseOver={this.mouseOverHandler}
          onMouseOut={this.mouseOutHandler}
          onClick={this.clickHandler}
          style={{
            "font-size": scale(
              clamp(this.props.text.length, this.textLengthDomain),
              this.textLengthDomain,
              this.fontSizeRange
            ),
          }}
        >
          <ReactAudioPlayer
            ref={(element) => {
              this.audio = element;
            }}
            src={this.props.audioSrc}
            onEnded={this.onAudioEnded}
            onError={this.onAudioEnded}
          />
          {this.props.text}
        </div>
      );
    } else {
      return <div />;
    }
  }
  mouseOverHandler() {
    this.props.mouseOverHandler(this.props.index);
  }
  mouseOutHandler() {
    this.props.mouseOutHandler(this.props.index);
  }
  clickHandler() {
    this.clicked = true;
    this.props.clickHandler(this.props.index);
    if (this.audioEnded) this.props.completionHandler(this.props.index);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.audioSrc !== prevProps.audioSrc) {
      this.clicked = false;
      this.audioEnded = false;
    }
    const isActive = this.props.activeIndex === this.props.index;
    const wasActive = prevProps.activeIndex === prevProps.index;
    if (!wasActive && isActive) {
      if (this.audio.audioEl.error === null) {
        this.audio.audioEl.currentTime = 0;
        this.audio.audioEl.play();
      }
    }
    if (wasActive && !isActive) {
      if (this.audio.audioEl.error === null) {
        this.audio.audioEl.pause();
      }
    }
  }
  getClassNames() {
    const classNames = this.baseClassNames.slice();
    classNames.push("pt-dialogue-available");
    if (this.props.activeIndex === this.props.index)
      classNames.push("pt-dialogue-active");
    return classNames.join(" ");
  }
  onAudioEnded() {
    this.audioEnded = true;
    if (this.clicked) this.props.completionHandler(this.props.index);
  }
}

class PTMeDialogue extends PTSelectableDialogue {
  constructor(props) {
    super(props);
    this.baseClassNames = ["pt-dialogue-me", "inky-output"];
  }
}

export { PTSelectableDialogue, PTMeDialogue };



// WEBPACK FOOTER //
// ./src/selectable_dialogue.js